export function initDraw(options = {}) {
	const drawArea = document.getElementById('drawArea');
	const drawPath = document.getElementById('drawPath');
	const shapeSelect = document.getElementById('shapeSelect');
	const status = document.getElementById('status');
	const clearBtn = document.getElementById('clearBtn');
	const saveBtn = document.getElementById('saveBtn');
    const drawAssignment = document.getElementById('drawAssignment');
	const newAssignment = document.getElementById('newAssignment');
	const drawMeterFill = document.getElementById('drawMeterFill');
	const drawMeterText = document.getElementById('drawMeterText');
	const drawRoot = document.getElementById('drawApp');
	const drawMeter = drawRoot ? drawRoot.querySelector('.draw__meter') : null;

	if (!drawArea || !drawPath || !shapeSelect || !status || !clearBtn || !saveBtn) {
		return;
	}

	const assignments = options.assignments || {};
	const appMode = options.appMode || 'test';
	const onLiveSubmitGesture = typeof options.onLiveSubmitGesture === 'function'
		? options.onLiveSubmitGesture
		: null;
	const onLiveViewTransition = typeof options.onLiveViewTransition === 'function'
		? options.onLiveViewTransition
		: null;
	const configuredMax = Number(options.drawMaxPathLength);
	const MIN_POINT_DISTANCE = 1.8;
	const maxPathLength = Number.isFinite(configuredMax)
		? Math.max(500, Math.min(20000, Math.floor(configuredMax)))
		: 3900;

	let strokes = [];
	let currentStroke = null;
	let drawing = false;

function setStatus(text, type = 'default') {
	if (typeof type === 'boolean') {
		type = type ? 'error' : 'default';
	}
	status.textContent = text;
	status.dataset.statusType = type;
	status.classList.remove('error', 'succes');
	if (type === 'error' || type === 'succes') {
		status.classList.add(type);
	}
}

function setDimmedState(dimmed) {
	drawArea.classList.toggle('dimmed', dimmed);
	if (drawMeter) {
		drawMeter.classList.toggle('dimmed', dimmed);
	}
	clearBtn.classList.toggle('dimmed', dimmed);
	saveBtn.classList.toggle('dimmed', dimmed);
	if (drawAssignment) {
		drawAssignment.classList.toggle('dimmed', dimmed);
	}
	if (newAssignment) {
		newAssignment.classList.toggle('dimmed', dimmed);
	}
}

function getPoint(event) {
	const rect = drawArea.getBoundingClientRect();
	const clientX = event.clientX ?? (event.touches && event.touches[0] ? event.touches[0].clientX : 0);
	const clientY = event.clientY ?? (event.touches && event.touches[0] ? event.touches[0].clientY : 0);
	const x = ((clientX - rect.left) / rect.width) * 300;
	const y = ((clientY - rect.top) / rect.height) * 300;
	return {
		x: Math.max(0, Math.min(300, Math.round(x * 10) / 10)),
		y: Math.max(0, Math.min(300, Math.round(y * 10) / 10))
	};
}

function pointsToPath(list) {
	if (list.length === 0) {
		return '';
	}
	if (list.length === 1) {
		return `M ${list[0].x} ${list[0].y}`;
	}
	let result = `M ${list[0].x} ${list[0].y}`;
	for (let i = 1; i < list.length; i += 1) {
		result += ` L ${list[i].x} ${list[i].y}`;
	}
	return result;
}

function distance(a, b) {
	const dx = a.x - b.x;
	const dy = a.y - b.y;
	return Math.sqrt((dx * dx) + (dy * dy));
}

function reduceStrokePoints(stroke, minDistance = MIN_POINT_DISTANCE) {
	if (stroke.length <= 2) {
		return stroke;
	}

	const reduced = [stroke[0]];
	let lastKept = stroke[0];

	for (let i = 1; i < stroke.length - 1; i += 1) {
		const point = stroke[i];
		if (distance(point, lastKept) >= minDistance) {
			reduced.push(point);
			lastKept = point;
		}
	}

	const endPoint = stroke[stroke.length - 1];
	if (distance(endPoint, lastKept) > 0) {
		reduced.push(endPoint);
	}

	return reduced;
}

function simplifyStrokes(strokeList, minDistance = MIN_POINT_DISTANCE) {
	return strokeList
		.map((stroke) => reduceStrokePoints(stroke, minDistance))
		.filter((stroke) => stroke.length > 0);
}

function countPoints(strokeList) {
	return strokeList.reduce((sum, stroke) => sum + stroke.length, 0);
}

function buildPathMetrics(strokeList) {
	let minDistance = MIN_POINT_DISTANCE;
	let simplified = simplifyStrokes(strokeList, minDistance);
	let path = strokesToPath(simplified);

	while (path.length > maxPathLength && minDistance < 6) {
		minDistance += 0.8;
		simplified = simplifyStrokes(strokeList, minDistance);
		path = strokesToPath(simplified);
	}

	return {
		path,
		pathLength: path.length,
		pointCount: countPoints(simplified),
	};
}

function buildSubmissionPath(strokeList) {
	return buildPathMetrics(strokeList).path;
}

function strokesToPath(strokeList) {
	if (strokeList.length === 0) {
		return '';
	}

	return strokeList
		.map((stroke) => pointsToPath(stroke))
		.filter((segment) => segment !== '')
		.join(' ');
}

function countDrawableStrokes(strokeList) {
	return strokeList.filter((stroke) => stroke.length >= 2).length;
}

function redraw() {
	drawPath.setAttribute('d', strokesToPath(strokes));
	updateComplexityMeter();
}

function updateComplexityMeter() {
	if (!drawMeterFill || !drawMeterText) {
		return;
	}

	const metrics = buildPathMetrics(strokes);
	const ratio = Math.min(1, metrics.pathLength / maxPathLength);
	const percentage = Math.round(ratio * 100);

	drawMeterFill.style.width = `${percentage}%`;

	const charsPerPoint = metrics.pointCount > 0 ? (metrics.pathLength / metrics.pointCount) : 12;
	const safeCharsPerPoint = Math.max(6, charsPerPoint);
	const remainingChars = Math.max(0, maxPathLength - metrics.pathLength);
	const pointsLeft = Math.floor(remainingChars / safeCharsPerPoint);

	drawMeterText.textContent = `Complexity ${percentage}% • approx ${pointsLeft} points left`;
}

function beginDraw(event) {
	drawing = true;
	setDimmedState(false);
	currentStroke = [getPoint(event)];
	strokes.push(currentStroke);
	if (status.dataset.statusType === 'error') {
		setStatus('');
	}
	redraw();
}

function moveDraw(event) {
	if (!drawing) {
		return;
	}
	if (!currentStroke) {
		return;
	}
	const nextPoint = getPoint(event);
	const lastPoint = currentStroke[currentStroke.length - 1];
	if (!lastPoint || distance(nextPoint, lastPoint) >= MIN_POINT_DISTANCE) {
		currentStroke.push(nextPoint);
	}
	redraw();
}

function endDraw() {
	drawing = false;
	currentStroke = null;
}

drawArea.addEventListener('pointerdown', (event) => {
	event.preventDefault();
	beginDraw(event);
});
drawArea.addEventListener('pointermove', (event) => {
	event.preventDefault();
	moveDraw(event);
});
drawArea.addEventListener('pointerup', endDraw);
drawArea.addEventListener('pointerleave', endDraw);

clearBtn.addEventListener('click', () => {
	strokes = [];
	currentStroke = null;
	redraw();
	setStatus('doen we!');
});

if (newAssignment && shapeSelect) {
	newAssignment.addEventListener('click', () => {
		const keys = Object.keys(assignments);
		const randomKey = keys[Math.floor(Math.random() * keys.length)];
		shapeSelect.value = randomKey;
		setStatus(`New assignment: ${assignments[randomKey]}`);
	});
}

saveBtn.addEventListener('click', async () => {
	if (appMode === 'live' && onLiveSubmitGesture) {
		onLiveSubmitGesture();
	}

	const metrics = buildPathMetrics(strokes);
	const path = metrics.path;
	if (!path || countDrawableStrokes(strokes) === 0) {
		setStatus('Teken eerst iets.', true);
		return;
	}

	if (path.length > maxPathLength) {
		setStatus('Te veel detail, dat kan eenvoudiger!', true);
		return;
	}    

	saveBtn.disabled = true;
	setStatus('Saving...');

	try {
		const response = await fetch('api.php?action=save', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				shape: shapeSelect.value,
				path,
				canvas_size: 300
			})
		});

		const data = await response.json();
		if (!response.ok || !data.ok) {
			if (response.status === 429) {
				setStatus('Je hebt al 3 tekeningen ingestuurd, dankjewel! Je wordt nu doorgestuurd.', 'succes');
				setDimmedState(true);
				setTimeout(() => {
					window.location.href = '?mode=view';
				}, 3000);
				return;
			}
			throw new Error(data.error || 'Save failed');
		}

		setStatus('Bedankt!', 'succes');
		setDimmedState(true);

		strokes = [];
		currentStroke = null;
		redraw();

		// In 'live' or 'sim' mode, switch to view without hard navigation.
		if (appMode === 'live' || appMode === 'sim') {
			let switchedInline = false;
			if (onLiveViewTransition) {
				switchedInline = await onLiveViewTransition({ shape: shapeSelect.value });
			}

			if (!switchedInline) {
				setTimeout(() => {
					window.location.href = '?mode=view';
				}, 800);
			}
		}
	} catch (error) {
		setStatus(error.message || 'Save failed.', true);
		saveBtn.disabled = false;
	}
});

updateComplexityMeter();
}
